import { Link as RouterLink } from 'react-router-dom'
import { FormattedDate } from 'react-intl'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import DnsIcon from '@mui/icons-material/Dns'
import { useTeam } from '../../contexts/TeamContext'
import { useNodes } from '../../contexts/NodesContext'
import { useServices } from '../../contexts/ServicesContext'
import { useNodeTasks } from '../../contexts/NodeTasksContext'
import ServiceStatusIndicator from './ServiceStatusIndicator'
import ServiceActionButtons from './ServiceActionButtons'
import ServiceDomainsChips from './ServiceDomainsChips'
import ServiceManagedByChip from './ServiceManagedByChip'
import ResourceList from './layouts/ResourceList'
import ResourceListRow from './layouts/ResourceListRow'
import ResourceListCell from './layouts/ResourceListCell'
import FlexColumn from './layouts/FlexColumn'
import Flex from './layouts/Flex'

function ServicesList({ services, project }) {
  const { team } = useTeam()
  const { nodesById } = useNodes()
  const { activeTaskByServiceId, reload: reloadNodeTasks } = useNodeTasks()
  const { reload } = useServices()

  const renderService = (service) => {
    const pendingTask = activeTaskByServiceId[service.id]
    const serviceUrl = `/teams/${team.slug}/docker/projects/${project?.slug}/services/${service.slug}`

    return (
      <ResourceListRow key={service.id} to={serviceUrl}>
        <ResourceListCell width={40}>
          <ServiceStatusIndicator service={service} pendingTask={pendingTask} />
        </ResourceListCell>
        <ResourceListCell grow>
          <FlexColumn gap={0.5}>
            <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>
              {service.name}
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {service.image}
            </Typography>
            <Flex gap={1} sx={{ flexWrap: 'wrap', alignItems: 'center' }}>
              <ServiceDomainsChips serviceId={service.id} />
              <ServiceManagedByChip service={service} project={project} />
              {project.nodeIds
                .map((nodeId) => nodesById[nodeId])
                .filter(Boolean)
                .map((node) => (
                  <Chip
                    key={node.id}
                    icon={<DnsIcon />}
                    label={node.name}
                    size="small"
                    color="secondary"
                    clickable
                    component={RouterLink}
                    to={`/teams/${team.slug}/nodes/${node.id}`}
                  />
                ))}
            </Flex>
          </FlexColumn>
        </ResourceListCell>
        <ResourceListCell minWidth={100}>
          <Typography variant="body2" color="text.secondary">
            <FormattedDate
              value={service.createdAt}
              year="numeric"
              month="short"
              day="numeric"
            />
          </Typography>
        </ResourceListCell>
        <ResourceListCell stopPropagation>
          <ServiceActionButtons
            service={service}
            project={project}
            pendingTask={pendingTask}
            onUpdate={() => { reload(); reloadNodeTasks() }}
          />
        </ResourceListCell>
      </ResourceListRow>
    )
  }

  return (
    <ResourceList
      items={services}
      renderItem={renderService}
      emptyMessageId="dockerServices.empty"
    />
  )
}

export default ServicesList
